import React, { useEffect, useRef, useState } from "react";
import NavigationBar from "../components/Nav/navigationBar";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";

export default function ContactUs() {
  const [visibleSections, setVisibleSections] = useState([]);
  const sectionsRef = useRef([]);

  const setSectionRef = (el, index) => {
    sectionsRef.current[index] = el;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => [...prev, entry.target.id]);
          }
        });
      },
      { threshold: 0.2 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  const isVisible = (id) => visibleSections.includes(id);

  return (
    <div className="overflow-x-hidden pt-32">
      <NavigationBar />

      {/* Hero Section */}
      <section
        id="hero"
        ref={(el) => setSectionRef(el, 0)}
        className={`relative bg-orange-200 py-32 transition-all duration-1000 ${
          isVisible("hero")
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10"
        }`}
      >
        <div className="relative z-10 text-center px-4 sm:px-6">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-4">
            Contact Us
          </h1>
          <p className="text-lg sm:text-xl text-gray-700 max-w-2xl mx-auto">
            We'd love to hear from you! Reach out for any queries or feedback.
          </p>
        </div>
      </section>

      {/* Contact Info */}
      <section
        id="info"
        ref={(el) => setSectionRef(el, 1)}
        className={`py-20 px-4 sm:px-6 md:px-12 transition-all duration-1000 ${
          isVisible("info")
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10"
        }`}
      >
        <div className="max-w-6xl mx-auto text-center grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="flex flex-col items-center bg-white p-6 rounded-xl shadow-md">
            <FaMapMarkerAlt className="text-orange-400 text-4xl mb-3" />
            <h3 className="font-bold text-xl mb-1">Address</h3>
            <p className="text-gray-600 text-center">
              Penukonda, Andhra Pradesh, India
            </p>
          </div>
          <div className="flex flex-col items-center bg-white p-6 rounded-xl shadow-md">
            <FaPhone className="text-orange-400 text-4xl mb-3" />
            <h3 className="font-bold text-xl mb-1">Phone</h3>
            <p className="text-gray-600 text-center">+91 98765 43210</p>
          </div>
          <div className="flex flex-col items-center bg-white p-6 rounded-xl shadow-md">
            <FaEnvelope className="text-orange-400 text-4xl mb-3" />
            <h3 className="font-bold text-xl mb-1">Email</h3>
            <p className="text-gray-600 text-center">info@babafakruddin.com</p>
          </div>
        </div>
      </section>
    </div>
  );
}
